import styled from "styled-components";
import {Button, Modal} from "react-bootstrap";


export const ModalImg = styled.img`
  object-fit: contain;
  width: 100%;
  max-height: 70vh;
`

export const ModalContext = styled.div`
  display: flex;
`

export const ModalHeader = styled(Modal.Header)`
  @media (max-width: 760px) {
    button {
      &:hover {
        background: transparent;
        color: #198754;
      }
    }
  }
`
